import type { ApiError } from '@/lib/api/apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'

export function throwServiceError(error: unknown, defaultMessage: string): never {
  const apiError = error as ApiError & { data?: unknown; errors?: Record<string, string[]> }
  throw {
    message: extractErrorMessage(error, defaultMessage),
    status: apiError.status,
    // Preserve API body for showApiError / formatApiError (Angular notify(error.error, 0))
    data: apiError.data,
    errors: apiError.errors,
  } as ApiError & { data?: unknown }
}

export function unwrapArrayPayload<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data as T[]
  if (data && typeof data === 'object' && 'data' in data) {
    const wrapped = (data as { data: unknown }).data
    return Array.isArray(wrapped) ? (wrapped as T[]) : []
  }
  return []
}
